import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useAppSelector from 'hooks/useAppSelector';
import useBreakPoints from 'hooks/useBreakPoints';
import { selectUpsInfo } from 'store/reducers/shopSlice';
import styled from 'styled-components/macro';
import { getIcon } from 'utils/icons';
import Carousel from '../Carousel/Carousel';

export const Usp = () => {
    const bp = useBreakPoints();
    const uspInfo = useAppSelector(selectUpsInfo);

    if (!uspInfo?.upsItems?.length) return null;

    const items = uspInfo.upsItems.map((item, index) => {
        const iconDef = getIcon(item.icon);
        return (
            <UspItem key={index}>
                {iconDef && <UspIcon icon={iconDef} />}
                <span>{item.text}</span>
            </UspItem>
        );
    });

    if (bp.lgBelow) {
        return (
            <UspBase $bgColor={uspInfo?.upsBgColor ?? undefined} $textColor={uspInfo?.upsTextColor ?? undefined}>
                <Carousel slidesToShow={1} slidesPerRow={1} autoplay={true} arrows={false} autoplaySpeed={4500}>
                    {items}
                </Carousel>
            </UspBase>
        );
    }

    return (
        <UspBar $bgColor={uspInfo?.upsBgColor ?? undefined} $textColor={uspInfo?.upsTextColor ?? undefined}>
            {items.slice(0, 3)}
        </UspBar>
    );
};

const UspBase = styled.div<{ $bgColor?: string; $textColor?: string }>`
    background: ${({ $bgColor }) => $bgColor ?? '#333'};
    color: ${({ $textColor }) => $textColor ?? '#fff'};
    font-size: 14px;
    font-weight: 600;
    padding: 24px 16px;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
`;

const UspBar = styled(UspBase)`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    min-height: 40px;
    gap: 48px;
`;

const UspItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

const UspIcon = styled(FontAwesomeIcon)`
    margin-right: 4px;
`;

export default Usp;
